<div>
  <se-fe-card>
<se-fe-card-header seFeDataTitle="When to use"></se-fe-card-header>
<se-fe-card-content>
  <p>This app is a standalone angular app that lives at <a href="https://user.sportngin.com/setup/">https://user.sportngin.com/setup/</a></p>
  <p>The associated libraries are specific to this app and should not be used outside of it.</p>
  <p>There are currently 4 modules</p>
  <ul>
    <li>
      <p>Account: The standard sign up flow. It is a fork from the now-defunct se-create-account-ui app. It lives at
      <a href="https://user.sportngin.com/setup/account" target="_blank">Production</a> | <a href="https://user.stage.ngin-staging.com/setup/account" target="_blank">Staging</a>.</p>
    </li>
    <li>
      <p>Household: This is the household creation flow for Profile Module.
        It is currently used for account creation when purchasing a membership,
        but will be expanded to replace the Create Account module above. It lives at
        <a href="https://user.sportngin.com/setup/household" target="_blank">Production</a> | <a href="https://user.stage.ngin-staging.com/setup/household" target="_blank">Staging</a>.
      </p>
    </li>
    <li>
      <p>Membership: This consists of the persona picker page in the membership purchase flow in Profile Module. It lives at
        <a href="https://user.sportngin.com/setup/membership" target="_blank">Production</a> | <a href="https://user.stage.ngin-staging.com/setup/membership" target="_blank">Staging</a>.
      </p>
    </li>
    <li>
      <p>MFA Onboarding: Page that prompts admins to verify their phone number and set up MFA for their account. It lives at
        <a href="https://user.sportngin.com/setup/mfa-onboarding" target="_blank">Production</a> | <a href="https://user.stage.ngin-staging.com/setup/mfa-onboarding" target="_blank">Staging</a>.
      </p>
    </li>
  </ul>
  <p>To run this app locally, checkout the repo then run</p>
  <se-fe-docs-code [code]="code.setup"></se-fe-docs-code>
  <p>then to run against staging, run</p>
  <se-fe-docs-code [code]="code.start"></se-fe-docs-code>
  <p>to run against local services, run</p>
  <se-fe-docs-code [code]="code.startDev"></se-fe-docs-code>
  <p>Then navigate to</p>
  <p><a href="https://household-setup.ui.sportngin.com.dev/setup/account">https://household-setup.ui.sportngin.com.dev/setup/account</a> for the account creation</p>
  <p><a href="https://household-setup.ui.sportngin.com.dev/setup/household">https://household-setup.ui.sportngin.com.dev/setup/household</a> for the household setup</p>
  <p><a href="https://household-setup.ui.sportngin.com.dev/setup/membership">https://household-setup.ui.sportngin.com.dev/setup/membership</a> for the membership persona picker</p>
  <p><a href="https://household-setup.ui.sportngin.com.dev/setup/mfa-onboarding">https://household-setup.ui.sportngin.com.dev/setup/mfa-onboarding</a> for the MFA onboarding</p>
</se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header seFeDataTitle="Account Module"></se-fe-card-header>
    <se-fe-card-content>
      The account module is the result of a migration/refactor
      of the now deprecated se-create-account project.

      It is the standard default flow for a user creating a new account.
      The name, email and phone number provided by the user are used to
      check for existing possible duplicate accounts and the user is
      presented with options to sign in using those accounts instead, or
      to continue creating a new account.
    </se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header seFeDataTitle="Feature: Account Info"></se-fe-card-header>
    <se-fe-card-content>
      <se-po-household-setup-account-info></se-po-household-setup-account-info>
    </se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header
      seFeDataTitle="Feature: Already Have an Account?"
      seFeDataSubtitle="This is embedded into other components - see above in Account Info for example"
    ></se-fe-card-header>
    <se-fe-card-content>
      <se-po-household-setup-already-have-account></se-po-household-setup-already-have-account>
    </se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header
      seFeDataTitle="Feature: Match"
      seFeDataSubtitle="Potential duplicates were found based on name, email, dob, phone"
    ></se-fe-card-header>
    <se-fe-card-content>
      <se-po-household-setup-match></se-po-household-setup-match>
    </se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header
      seFeDataTitle="Feature: Create Password"
      seFeDataSubtitle="Final step of account creation is when the user creates a password"
    ></se-fe-card-header>
    <se-fe-card-content>
      <se-po-household-setup-create-password></se-po-household-setup-create-password>
    </se-fe-card-content>
  </se-fe-card>

  <se-fe-card>
    <se-fe-card-header
      seFeDataTitle="Feature: Verification"
      seFeDataSubtitle="After account creation the user is prompted to verify their email address by clicking a link"
    ></se-fe-card-header>
    <se-fe-card-content>
      <se-po-household-setup-verification></se-po-household-setup-verification>
    </se-fe-card-content>
  </se-fe-card>
</div>
